import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPaginationModule } from "ngx-pagination";
import { HighlightDirective } from "./directive/highlight.directive";
import { AccountVerificationComponent } from "./components/account-verification/account-verification.component";
import { AddAccountnameComponent } from "./components/add-accountname/add-accountname.component";
import { ChangeNumberFormComponent } from "./components/change-number-form/change-number-form-component";
import { ChangeNumberComponent } from "./components/change-number/change-number.component";
import { ConflictingModalComponent } from "./components/conflicting-modal/conflicting-modal.component";
import { DownloadManagelinesModalComponent } from "./components/download-managelines-modal/download-managelines-modal.component";
import { EditPasswordComponent } from "./components/edit-password/edit-password.component";
import { EvaluatePromotionComponent } from "./components/evaluate-promotion/evaluate-promotion.component";
import { LineIdentifierComponent } from "./components/line-identifier/line-identifier.component";
import { RestoreComponent } from "./components/restore/restore.component";
import { SimChangeFormComponent } from "./components/sim-change/sim-change-form/sim-change-form.component";
import { SimChangeComponent } from "./components/sim-change/sim-change.component";
import { SuspendComponent } from "./components/suspend/suspend.component";
import { TransferNumberComponent } from "./components/transfer-number/transfer-number.component";
import { MaterialModule } from "../material.module";
import { NgSelectModule } from '@ng-select/ng-select';

import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { ServiceAgreementComponent } from "./components/service-agreement/service-agreement.component";
import { SignOffComponent } from "./components/sign-off/sign-off.component";
import { SuccessComponent } from "./components/success/success.component";
import { TermsAndConditionsComponent } from "./components/terms-and-conditions/terms-and-conditions.component";
import { CustomFilterPipe } from "./pipes/custom-filter.pipe";
import { FormatMsisdnPipe } from "./pipes/format-msisdn.pipe";
import { MsisdnPipe } from "./pipes/msisdn.pipe";
import { SplitNpaNpxPipe } from "./pipes/npa-npx-split-pipe/npa-npx-split-pipe";
import { PhonePipe } from "./pipes/phone.pipe";
import { SearchPipePipe } from "./pipes/search-pipe.pipe";
import { UdfFormatPipe } from "./pipes/udf-format.pipe";
import { PhoneMaskDirective } from "./directive/phone-mask.directive";
import { TechnicalDifficultiesModalComponent } from "./components/technical-difficulties-modal/technical-difficulties-modal.component";
import { IndividualAlertModalComponent } from "./components/individual-alert-modal/individual-alert-modal";
import { SubmitDocumentationFailureComponent } from "./components/submit-documentation-failure/submit-documentation-failure.component";
import { SkeletonLoaderComponent } from "../common/components/skeleton-loader/skeleton-loader.component";
import { DeviceQueryErrorComponent } from "./components/device-query-error/device-query-error.component";
import { CommonConfirmationModalComponent } from './components/common-confirmation-modal/common-confirmation-modal.component';
import { BasicPopupModalComponent } from './components/basic-popup-modal/basic-popup-modal.component';
import { SimChangeErrorComponent } from './components/sim-change-error/sim-change-error.component';
import { ConfirmOrCancelModalComponent } from './components/confirm-or-cancel-modal/confirm-or-cancel-modal.component';
import { DocumentsPendingComponent } from "../affiliations/common/documents-pending/documents-pending.component";
import { ManagePairingComponent } from './components/manage-pairing/manage-pairing.component';
import { ManagePairingMultilineComponent } from './components/manage-pairing-multiline/manage-pairing-multiline.component';
import { ReviewModalComponent } from "../bulk/components/review-modal/review-modal.component";
import { PartnerSubscriptionRedemptionPopupModalComponent } from "./components/partner-subscription-redemption-popup-modal/partner-subscription-redemption-popup-modal.component";
import { CommonMultilineBlockUnblockModalComponent } from "./components/common-multiline-block-unblock-modal/common-multiline-block-unblock-modal.component";
import { TpopComponent } from "./components/tpop/tpop.component";
import { SimProtectionBanLevel } from "./components/sim-protection-ban-level/sim-protection-ban-level.component";
import { MaskNumberPipe } from "./pipes/mask-number.pipe";

const declarations = [
  LoaderComponent,
  HeaderComponent,
  FooterComponent,
  SuccessComponent,
  ServiceAgreementComponent,
  TermsAndConditionsComponent,
  SignOffComponent,
  SkeletonLoaderComponent,
  HighlightDirective,
  PhoneMaskDirective,
  UdfFormatPipe,
  CustomFilterPipe,
  FormatMsisdnPipe,
  MsisdnPipe,
  PhonePipe,
  SearchPipePipe,
  SplitNpaNpxPipe,
  MaskNumberPipe,

  //temp
  EditPasswordComponent,
  AddAccountnameComponent,
  DownloadManagelinesModalComponent,
  AccountVerificationComponent,
  RestoreComponent,
  SuspendComponent,
  TransferNumberComponent,
  LineIdentifierComponent,
  ChangeNumberComponent,
  ChangeNumberFormComponent,
  SimChangeComponent,
  SimChangeFormComponent,
  ConflictingModalComponent,
  EvaluatePromotionComponent,
  IndividualAlertModalComponent,
  TechnicalDifficultiesModalComponent,
  SubmitDocumentationFailureComponent,
  DeviceQueryErrorComponent,
  CommonConfirmationModalComponent,
  BasicPopupModalComponent,
  SimChangeErrorComponent,
  ConfirmOrCancelModalComponent,
  DocumentsPendingComponent,
  ManagePairingComponent,
  ManagePairingMultilineComponent,
  ReviewModalComponent,
  PartnerSubscriptionRedemptionPopupModalComponent,
  CommonMultilineBlockUnblockModalComponent,
  TpopComponent,
  SimProtectionBanLevel
  //temp
];

@NgModule({
    declarations: [...declarations],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        NgxPaginationModule,
        RouterModule,
        NgbModule,
        NgSelectModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        NgxPaginationModule,
        NgbModule,
        NgSelectModule,
        RouterModule,
        ...declarations
    ]
})
export class SharedModule {
  constructor() {
    console.log('shared module loaded');
  }
}
